module.exports = __webpack_public_path__ + "static/CCQ_MetaisBasicos-f54b67267e5e88b92d760810dba141b6.png";